import { Toast } from 'buefy/dist/components/toast'

const toast = {
  error: (message) => {
    return Toast.open({
      type: 'is-danger',
      message: message,
    });
  },
  success: (message) => {
    return Toast.open(message);
  },
};

export default toast
